import { render, staticRenderFns } from "./UpdateStatusForm.vue?vue&type=template&id=745e4b10&scoped=true&"
import script from "./UpdateStatusForm.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStatusForm.vue?vue&type=style&index=0&id=745e4b10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745e4b10",
  null
  
)

export default component.exports